import { render } from "./AuthPageLayout.vue?vue&type=template&id=2ec3cec8&scoped=true"
const script = {}

import "./AuthPageLayout.vue?vue&type=style&index=0&id=2ec3cec8&scoped=true&lang=css"
import "./AuthPageLayout.vue?vue&type=style&index=1&id=2ec3cec8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec3cec8"]])

export default __exports__